import pendingPromise from 'utils/pendingPromise';

const cache = new Map();

const qs = new URLSearchParams(typeof location !== 'undefined' ? location.search : '');
export const previewMode = qs.has('cms-preview');

let previewDataWaitlist = {};
async function waitForPreviewData(name) {
	let promise = pendingPromise();
	previewDataWaitlist[name] ||= [];
	previewDataWaitlist[name].push(promise);
	return promise;
}

if (previewMode) {
	// const allowedOrigins = ['http://localhost:4010', 'https://demo.pow.io'];
	window.addEventListener('message', e => {
		// if (!allowedOrigins.includes(e.origin)) return;
		let message = e.data;
		if (message?.type === 'data' && previewDataWaitlist[message.name]) {
			previewDataWaitlist[message.name].forEach(p => p.resolve(message.data));
			previewDataWaitlist[message.name] = [];
		}
	}, false);
}

async function getDataRaw(name) {
	// simulate slowness
	// await new Promise(resolve => setTimeout(resolve, 1000));

	if (previewMode && window.parent !== window) {
		window.parent.postMessage({ type: 'requestData', name }, '*');
		let data = await waitForPreviewData(name);
		if (data !== null) return data;
	}

	if (name === 'navigation') {
		return (await import(/* webpackChunkName: 'navigation-data' */ './tmp/navigation.js')).default;
	} else if (name === 'about') {
		return (await import(/* webpackChunkName: 'about-data' */ './tmp/about.js')).default;
	} else if (name === 'landing') {
		return (await import(/* webpackChunkName: 'landing-data' */ './tmp/landing.js')).default;
	} else if (name === 'movie') {
		return (await import(/* webpackChunkName: 'movie-data' */ './tmp/movie.js')).default;
	} else if (name === 'releases') {
		return (await import(/* webpackChunkName: 'releases-data' */ './tmp/releases.js')).default;
	} else if (name === 'news') {
		return (await import(/* webpackChunkName: 'news-data' */ './tmp/news.js')).default;
	} else if (name === 'leadership') {
		return (await import(/* webpackChunkName: 'leadership-data' */ './tmp/leadership.js')).default;
	} else if (name === 'region') {
		return (await import(/* webpackChunkName: 'leadership-data' */ './tmp/region.js')).default;
	}
}

export async function getData(name) {
	if (cache.has(name)) {
		return cache.get(name);
	}
	const promise = getDataRaw(name);
	cache.set(name, promise);
	return promise;
}

export async function getYoutubePlaylist() {
	try {
		const response = await fetch(
			'https://youtube.s-prod.pow.io/getPlaylistData?playlistId=PLuq_rgCzEP_Nfzo3fFntwhGdMMiLG4GUb',
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
				},
			}
		);

		if (!response.ok) throw new Error('Network response was not ok');
		const data = await response.json();
		return data.items;
	} catch (error) {
		return error;
	}
}
